document.addEventListener('DOMContentLoaded', function() {
  // Get all tab elements
  const tabButtons = document.querySelectorAll('.collection-tabs .tab-button');
  const tabPanels = document.querySelectorAll('.collection-tabs .tab-panel');
  const tabsWrapper = document.querySelector('.collection-tabs .tabs-wrapper');
  const prevButton = document.querySelector('.collection-tabs .tab-prev');
  const nextButton = document.querySelector('.collection-tabs .tab-next');

  let currentTabIndex = 0;

  // Function to switch tabs
  function switchTab(index) {
    // Remove active class from all buttons and panels
    tabButtons.forEach(btn => btn.classList.remove('active'));
    tabPanels.forEach(panel => panel.classList.remove('active'));

    // Add active class to selected tab and panel
    tabButtons[index].classList.add('active');
    tabPanels[index].classList.add('active');

    // Update current tab index
    currentTabIndex = index;

    // Scroll the tab into view
    scrollTabIntoView(tabButtons[index]);

    // Update arrow visibility
    updateArrowVisibility();
  }

  // Function to scroll tab into view
  function scrollTabIntoView(tab) {
    const tabsWrapperRect = tabsWrapper.getBoundingClientRect();
    const tabRect = tab.getBoundingClientRect();
    
    // Calculate the scroll position needed to center the tab
    const scrollLeft = tab.offsetLeft - (tabsWrapperRect.width / 2) + (tabRect.width / 2);
    
    // Smooth scroll to the position
    tabsWrapper.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  }

  // Update arrow visibility based on current tab
  function updateArrowVisibility() {
    // Show/hide previous arrow based on current tab position
    prevButton.style.display = currentTabIndex > 0 ? 'flex' : 'none';
    
    // Always show next arrow if there's more than one tab
    nextButton.style.display = tabButtons.length > 1 ? 'flex' : 'none';
  }

  // Tab button click handlers
  tabButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      switchTab(index);
    });
  });

  // Arrow click handlers
  if(nextButton){
    nextButton.addEventListener('click', () => {
      // If at last tab, go to first tab, otherwise go to next tab
      const nextIndex = currentTabIndex === tabButtons.length - 1 ? 0 : currentTabIndex + 1;
      switchTab(nextIndex);
    });
  }

  if(prevButton){
    prevButton.addEventListener('click', () => {
      // Only go to previous tab if not on first tab
      if (currentTabIndex > 0) {
        switchTab(currentTabIndex - 1);
      }
    });
  }

  // Initialize arrows visibility
  if(prevButton) prevButton.style.display = 'none'; // Hide previous arrow initially
  if(nextButton) nextButton.style.display = tabButtons.length > 1 ? 'flex' : 'none'; // Show next arrow if multiple tabs
}); 